import { CODE_TO_APP_VALUE, languageDropDown } from './languageConstants';

// Mirrors the translations CMS base URL (TranslationsPage/api.js BASE_URL).
const LANGUAGES_URL = 'https://dev.localclarity.com/translations/api/admin/languages';

// Primary display order. Any active API code NOT listed here is appended AFTER these (in API order).
const ORDER = ['en-US', 'en-GB', 'pt', 'de', 'es', 'fr', 'ja', 'ar', 'it', 'nl', 'zh', 'hi', 'vi', 'th', 'fil'];
const orderIndex = (code) => {
    const i = ORDER.indexOf(code);
    return i === -1 ? ORDER.length : i;
};

let cache = null;

// Returns a Promise of ordered app name-values for the API's active languages.
// Falls back to the static languageDropDown values on any failure (no empty menu).
export const fetchLanguageValues = () => {
    if (cache) return cache;
    cache = fetch(LANGUAGES_URL, { cache: 'no-store' })
        .then((res) => res.json())
        .then((list) => (Array.isArray(list) ? list : [])
            .filter((lang) => lang.is_active)
            .sort((a, b) => orderIndex(a.code) - orderIndex(b.code))
            .map((lang) => CODE_TO_APP_VALUE[lang.code])
            .filter(Boolean))
        .catch(() => languageDropDown.map((option) => option.value));
    return cache;
};
